module.exports = __webpack_public_path__ + "img/logo-venom.b1359257.png";